import React, {Component} from 'react';
import {Button, Col, Drawer, Form, Input, InputNumber, Row, Select} from 'antd';
import {createAction, deleteAction, updateAction} from "../../services/ActionsService";

const {Option} = Select;

export class ActionsBase extends Component {

    deleteAction = (action) => {
        this.setState({isLoading: true});
        deleteAction(action).then(() => {
            this.props.onDelete(action);
        });
    };

    saveAction = () => {
        this.setState({isLoading: true});
        let action = this.state.action;
        action.clientId = this.props.client;
        let actionFunction = this.state.key === undefined ?
            createAction(action) :
            updateAction(action);
        actionFunction.then(actionFromDb => {
            this.props.onSave(actionFromDb);
            this.setState({
                editVisible: false
            });
        });
    };

    showDrawer = () => {
        this.setState({
            editVisible: true,
            keyValue: new Date().getTime(),
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.saveAction();
            }
        });
    };

    onClose = () => {
        this.setState({
            editVisible: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    handleActionValues = (property, value) => {
        let action = this.state.action;
        action[property] = value;
        this.setState({action: action});
    };

    handleActionConfigurationValues = (property, value) => {
        let action = this.state.action;
        action.configuration[property] = value;
        this.setState({action: action});
    };

    getKey = () => {
        return (this.state.key ? this.state.key : "") + (this.state.keyValue ? this.state.keyValue : "");
    };

    constructor(props) {
        super(props);

        let action = props.action;
        this.state = {
            key: action.id,
            action: action,
            editVisible: false,
            currentAction: props.currentAction,
            id: {
                value: ''
            },
        };
    };

    componentDidUpdate() {
        const changes = {
            currentAction: this.props.currentAction,
        };
        const values = this.props.currentAction ? JSON.stringify(changes) : "{}";
        if (!this.state.propValues || this.state.propValues !== values) {
            this.setState({
                propValues: values,
                groups: this.props.groups ? this.props.groups : this.state.groups,
                currentAction: this.props.currentAction ? this.props.currentAction : this.state.currentAction
            });
        }
    }

    customButtons(key, id) {
        return "";
    }

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        const key = this.getKey();

        return <span key={"editRow" + key}>
            <Drawer
                title="Acción"
                placement="right"
                closable={true}
                onClose={this.onClose}
                maskClosable={false}
                width={'calc((100% - 1000)>0?790:100%)'}
                visible={this.state.editVisible}
                key={"drawer-" + key}
                style={{
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: 53,
                }}>
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Nombre" required={true}>
                                {getFieldDecorator("name" + key, {
                                    initialValue: (this.state.action && this.state.action.name) ? this.state.action.name : "",
                                    rules: [{
                                        required: true,
                                        message: 'Este campo es obligatorio'
                                    }]
                                })(
                                    <Input placeholder="Nombre"
                                           onChange={(value) => {
                                               this.handleActionValues("name", value.target.value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Pin" required={true}>
                                {getFieldDecorator("keyPin" + key, {
                                    initialValue: (this.state.action && this.state.action.keyPin) ? this.state.action.keyPin : "",
                                    rules: [{
                                        required: true,
                                        message: 'Este campo es obligatorio'
                                    }]
                                })(
                                    <Input placeholder="Pin"
                                           onChange={(value) => {
                                               this.handleActionValues("keyPin", value.target.value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24} className="preview-area">
                            <Form.Item label="Tipo" required={true}>
                                {getFieldDecorator("configuration.type" + key, {
                                    initialValue: (this.state.action && this.state.action.configuration.type) ? this.state.action.configuration.type : "",
                                    rules: [{
                                        required: true,
                                        message: 'Este campo es obligatorio'
                                    }]
                                })(
                                    <Select placeholder="Tipo" required={true}
                                            onChange={(value) => {
                                                this.handleActionConfigurationValues("type", value)
                                            }}>
                                        <Option value="primary" label="primary">
                                                <Button type="primary" className="preview-btn"
                                                        icon={(this.state.action && this.state.action.configuration.icon) ? this.state.action.configuration.icon : ""}>
                                                    {(this.state.action && this.state.action.name) ? this.state.action.name : "..."}
                                                </Button>
                                        </Option>
                                        <Option value="default" label="default">
                                            <Button type="default" className="preview-btn"
                                                    icon={(this.state.action && this.state.action.configuration.icon) ? this.state.action.configuration.icon : ""}>
                                                {(this.state.action && this.state.action.name) ? this.state.action.name : "..."}
                                            </Button>
                                        </Option>
                                        <Option value="dashed" label="dashed">
                                            <Button type="dashed" className="preview-btn"
                                                    icon={(this.state.action && this.state.action.configuration.icon) ? this.state.action.configuration.icon : ""}>
                                                {(this.state.action && this.state.action.name) ? this.state.action.name : "..."}
                                            </Button>
                                        </Option>
                                        <Option value="danger" label="danger">
                                            <Button type="danger" className="preview-btn"
                                                    icon={(this.state.action && this.state.action.configuration.icon) ? this.state.action.configuration.icon : ""}>
                                                {(this.state.action && this.state.action.name) ? this.state.action.name : "..."}
                                            </Button>
                                        </Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Ícono" required={true}>
                                {getFieldDecorator("configuration.icon" + key, {
                                    initialValue: (this.state.action && this.state.action.configuration.icon) ? this.state.action.configuration.icon : "",
                                    rules: [{
                                        required: true,
                                        message: 'Este campo es obligatorio'
                                    }]
                                })(
                                    <Input placeholder="Ícono"
                                           onChange={(value) => {
                                               this.handleActionConfigurationValues("icon", value.target.value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Timpo de pulsación">
                                {getFieldDecorator("configuration.pin.pulse.time" + key, {
                                    initialValue: (this.state.action && this.state.action.configuration.pinPulseTime) ? this.state.action.configuration.pinPulseTime : "",
                                })(
                                    <InputNumber min={100} max={10000} step={100} placeholder="Timpo de pulsación"
                                           onChange={(value) => {
                                               this.handleActionConfigurationValues("pinPulseTime", value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Orden" required={true}>
                                {getFieldDecorator("order" + key, {
                                    initialValue: (this.state.action && this.state.action.order) ? this.state.action.order : 0,
                                    rules: [{
                                        required: true,
                                        message: 'Este campo es obligatorio'
                                    }]
                                })(
                                    <InputNumber min={0} max={100} placeholder="Orden"
                                           onChange={(value) => {
                                               this.handleActionValues("order", value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className="form-footer-separator">
                        <Button onClick={this.onClose}>Cancelar</Button>
                        <Button className="mrg-left" type="primary" htmlType="submit">Aceptar</Button>
                    </div>
                </Form>
            </Drawer>
            {
                this.customButtons(key, this.state.action.id)
            }
        </span>
    }

    translate(key) {
        return this.props.t(key);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/actions/ActionsBase.js